const useGetQueryParam = (param:string) => {
  const { search } = window.location;
  const value = new URLSearchParams(search).get(param) ?? '';
  return value;
};

export default useGetQueryParam;
